import { fetchApi } from '@/config/axiosSetting.ts';
import {
  InquiryPlateQueryParamsType,
  InquiryPlateResultType,
} from '@/common/queries/inquiryPlate/inquiryPlateQuery.type';
import { AxiosResponse } from 'axios';

export const inquiryPlateQueryFunction = (
  params: InquiryPlateQueryParamsType,
): Promise<AxiosResponse<string, string> | InquiryPlateResultType> => {
  return fetchApi.get(
    `/inquiry/${params.id}/vehicle_information/vehicle_inquiry/`,
    {
      params: {
        vehicle_plate: params.plate,
        national_code: params.nationalCode,
      },
    },
  );
};
